import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { handleChunkError, clearReloadFlag } from '@/utils/chunk-error-handler';
import App from './app.tsx';
import { getAppEnvironment, getAppVersion } from './config/env-config';
import { initializeTelemetry } from './telemetry/tracing';

// Initialize OpenTelemetry trace context propagation
// This must be called before any HTTP requests are made
initializeTelemetry({
  serviceName: 'user-portal',
  serviceVersion: getAppVersion(),
  environment: getAppEnvironment(),
});

// Handle chunk loading errors (happens after deployments)
window.addEventListener('unhandledrejection', event => {
  handleChunkError(event.reason);
});

// Clear reload flag on successful load
window.addEventListener('load', () => {
  clearReloadFlag();
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
